import { Box, IconButton, Select, Stack, Typography, useTheme } from "@mui/material";
import { LocalizationContext } from "../../localization/index.js";
import { makeCurrencyFormatter, price } from "../utils.js";
import { ModalEditionDifferences } from "./modal-edition-differences.js";
import { Option } from "./option.js";
import { ProductContext } from "../provider.js";
import { QuestionMarkIcon } from "../../icons.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
export const Variants = () => {
    const { t } = useTranslation(["c-product", "c-common"]);
    const { market } = React.useContext(LocalizationContext);
    const EDITIONS = ["print", "online"];
    const LANGUAGES = ["DE", "FR", "GB"];
    const EDITION_LABELS = {
        print: t("c-product:print-edition", "Gedruckte Ausgabe"),
        online: t("c-product:online-edition", "Online-Version"),
    };
    const LANGUAGE_LABELS = {
        DE: t("c-product:language-label-german", "Deutsch"),
        FR: t("c-product:language-label-french", "Französisch"),
        GB: t("c-product:language-label-english", "Englisch"),
    };
    const theme = useTheme();
    const useSelect = useMediaQuery(theme.breakpoints.down("sm"));
    const product = React.useContext(ProductContext);
    const [selectedLanguage] = React.useState("DE");
    const [selectedEdition] = React.useState(product.edition);
    const router = useRouter();
    const onlinePrice = price({ product, edition: "online", market });
    const printPrice = price({ product, edition: "print", market });
    const formatCurrency = makeCurrencyFormatter({ currency: onlinePrice.currency });
    const showEditionExplainer = () => NiceModal.show(ModalEditionDifferences);
    const handleEditionChange = (value) => {
        if (value === product.edition)
            return;
        const path = value === "online"
            ? t("c-common:slug-online", "online-krimidinner")
            : t("c-common:slug-print", "krimidinner");
        router.push(`/${path}/${router.query.slug}`);
    };
    React.useEffect(() => {
        const path = product.edition === "online"
            ? t("c-common:slug-print", "krimidinner")
            : t("c-common:slug-online", "online-krimidinner");
        router.prefetch(`/${path}/${router.query.slug}`);
    }, [product.edition, router, t]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { mt: 4, width: "100%", overflow: "hidden" } },
            React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", spacing: 1, sx: { pb: 0.5 } },
                React.createElement(Typography, { color: theme.palette.text.primary, component: "div", sx: { pt: 0, pb: 0 }, variant: "subtitle1" }, t("c-product:edition", "Ausgabe")),
                React.createElement(IconButton, { size: "small", onClick: showEditionExplainer },
                    React.createElement(QuestionMarkIcon, { sx: { fontSize: { xs: "20px", sm: "22px", md: "24px", lg: "30px" } } }))),
            useSelect && (React.createElement(Select, { fullWidth: true, native: true, variant: "outlined", onChange: (e) => handleEditionChange(e.target.value), sx: {
                    ...theme.typography.subtitle2,
                    overflow: "hidden",
                    pb: 0,
                    pt: 0,
                    wdith: "100%",
                }, value: product.edition }, EDITIONS.map((edition) => (React.createElement("option", { key: `edition-mobile-option-${edition}`, value: edition },
                EDITION_LABELS[edition],
                " \u2013",
                formatCurrency(price({ product, edition, market: market }).amount)))))),
            !useSelect && (React.createElement(Stack, { alignItems: "center", direction: "row", flexWrap: "wrap", spacing: { md: 1.5, lg: 2 }, sx: { mt: { xs: 0, lg: 0.5 } } }, EDITIONS.map((edition) => (React.createElement(Option, { onClick: () => handleEditionChange(edition), key: `edition-option-${edition}`, label: EDITION_LABELS[edition], selected: edition === selectedEdition }))))))));
};
//# sourceMappingURL=variants.js.map